import React from "react";
import { apiURL, apiPrefix } from "../../../utlis/config";
// import "./examForm.less";
import store from "store";
const InvoiceView = (props) => {
  var { original } = props;

  return (
    <div className="card m-20 p-25">
      <iframe
        // src="https://view.officeapps.live.com/op/embed.aspx?src=https://arabtechstore.com/api/invoice/5f5d5c50191dee4d14bb894c/invoice-5f5d5c50191dee4d14bb894c.docx"
        // src={`https://docs.google.com/gview?url=${apiURL}/invoice/${original._id}/invoice-${original._id}.docx`}
        src={`${apiURL}/invoice/${original._id}/invoice-${original._id}.pdf`}
        title="invoice"
        style={{ minHeight: 500 }}
      ></iframe>
    </div>
  );
};
export default InvoiceView;
